import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Video from './Video'
import Projects from './Projects'
import Links from './Links'
import ErrorPage from './ErrorPage'

const ScreensRouter = ({ setShowFaces }) => {
  return (
    <div className='screen-router'>
      <Routes>
        <Route path='/links' element={<Links setShowFaces={setShowFaces} />} />
        <Route path='/projects' element={<Projects />} />
        <Route path='/video' element={<Video />} />
        <Route path='/' />
        <Route path='*' element={<ErrorPage />} />
      </Routes>
    </div>
  )
}

export default ScreensRouter
